import React, { useState } from 'react';
// styles , icons and images
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { Button, TextField, Typography } from '@material-ui/core';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleFilled';
import img from '../../../images/person-placeholder.jpg'

// this component respresents the Explore opportunities page

export default function SideProfileInfo(props) {
    let userData = props.data;
    const [showVideo , setShowData ] = useState(false);

    const handleCloseVideo = () => setShowData(false);
    const handleShowVideo = () => setShowData(true);
    const ProfileImge = () => (
        <Col className="p-0 text-center" md={12}>
            <figure className="p-relative m-auto" style={{ width: "150px", height: "150px" }}>
                <img
                    style={{ height: '100%', width: '100%' }}
                    className="shadow rounded-circle"
                    src={userData?.profile_image? userData.profile_image.url : img}
                    alt="" />
            </figure>
        </Col>
    )
    const YearsOfExperience = () => (
        <Col className="p-0 mt-3 text-center" md={12}>
            <div>
            <div><p className="mb-0 text-grey">{userData?.years_of_experience > 1 ? `${userData?.years_of_experience} Years of experience` : `${userData?.years_of_experience} Year of experience` }</p></div>
                <div><h4 className="captialize">{userData?.name}</h4></div>
                <div><h6 className="bold">{userData?.headlines}</h6></div>
            </div>
            <Button size="small" className="btn-white-outline w-100">Send Message</Button>
        </Col>
    )
    const Bio = () => (
        (userData.bio) &&
            <Col className="p-0" md={12}>
                <Row className="m-0">
                    <Col className="p-0 text-left">
                        <h5>Bio</h5>
                    </Col>
                </Row>
                <div>
                    <p className="mb-0">
                        {userData.bio}
                    </p>
                </div>
                <div className="w-100 border-bottom mt-3 mb-3"></div>
            </Col>
    )
    const ProfileVisume = () => (
        <Col className="p-0" md={12}>
            <title className="">
              {userData?.my_bio && <h5>Profile Visume</h5>} 
            </title>
           { userData.my_bio &&
            <div>
                <button
                    type="button"
                    className="bg-transparent border-0 p-0 play-icon-container w-100"
                    onClick={e => handleShowVideo()}>
                    <img className="rounded" src={userData.my_bio.video?.frame? userData.my_bio.video.frame.url : "https://via.placeholder.com/150"} alt="video poster" width="100%" style={{ maxHeight: '6.5rem' }} />
                    <div className="text-white play-icon row m-0 align-items-center">
                        <PlayCircleOutlineIcon style={{ fontSize: '2.5rem' }} className="col" />
                    </div>
                </button>
                <div>
                    <Row className="m-0">
                        <Col  className="text-left p-0 bold mt-3 captialize">{userData?.my_bio?.title}</Col>
                     </Row>
                    <Row className="m-0 p-0 align-items-start mt-1 w-100">
                        <Col md={6} className="text-left p-0"><p className="text-orange mb-0 bold" style={{ fontSize: '12px' }}>{userData?.my_bio?.speciality?.name}</p></Col>
                        <Col md={6} className="text-right p-0"><p className="text-grey mb-0" style={{ fontSize: '12px' }}>{userData?.my_bio?.video?.duration} sec</p></Col>
                        <Col md={6}  className="text-left p-0"><p className="text-grey mb-0" style={{ fontSize: '12px' }}>{userData?.my_bio?.created_at.substring(0,10)}</p></Col>

                    </Row>
                </div>
                <div>
                    {userData?.profile_pdf &&
                        <a href={userData?.profile_pdf?.url} >{userData?.profile_pdf?.url && userData?.name+' \'s CV'}</a>
                    }
                </div>
            </div>
            }   
        </Col>
    )
    const VideoPopUp = () => (
        userData.my_bio  && 
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="row m-0 modal-video pr-0 biographies"
                show={showVideo}
                onHide={handleCloseVideo}>
                <Col xs={12} className="p-0">
                    <Modal.Body className="row m-0 p-0  bg-white rounded border-0">
                        <Col xs={12} className="text-left p-0 bold p-2 pt-3 pb-2 captialize">
                            <h6>{userData.my_bio.title}</h6>
                        </Col>
                        <Col md={12}  className="p-0 order-sm-4 order-2 bg-black rounded">
                            <video controls autoPlay className="custom-iframe" title={userData.my_bio.title} src={(userData.my_bio.video) ? userData.my_bio.video.url : ''} width="100%" style={{ maxHeight: '33rem' }}></video>
                        </Col>
                        {/* <Col md={2} xs={12} className="bg-lightgrey order-sm-5 order-5 modal-list-hight pr-1 pl-1">
                            {
                                userData.my_bio.questions.map(question =>
                                    (question.video !== null) ?
                                        <button type="button"
                                            className="bg-transparent btn-cuePoint p-0 w-100 rounded border-bottom border-0"
                                            onClick={e => {
                                                let video = document.querySelector('.custom-iframe');
                                                video.currentTime = question.start_time
                                            }}>
                                            <Row className="m-0  pb-2">
                                                <Col xs={1} className="p-0">
                                                    <EmojiFlagsIcon style={{ fontSize: "1rem" }} />
                                                </Col>
                                                <Col xs={11} className="p-0  text-left">
                                                    <p className="d-inline-block pl-2 captialize mb-0">
                                                        {(question.title.length <= 15) ? question.title : question.title.substring(0, 15) + "..."}
                                                    </p>
                                                </Col>
                                            </Row>
                                        </button> : ''
                                )
                            }
                        </Col> */}
                    </Modal.Body>
                </Col>
            </Modal>
    )
    return (
        <>
            <Row className="w-100 pr-4 pl-4 m-0">
                <ProfileImge />
                <YearsOfExperience />
                <Col md={12} className="w-100 border-bottom mt-3 mb-3"></Col>
                <Bio />
                <ProfileVisume />
            </Row>
            <VideoPopUp/>
        </>
    );
}


